import { FC, forwardRef } from "react";
import { styled, Theme } from "@mui/material/styles";
import MUICheckBox, { CheckboxProps } from "@mui/material/Checkbox";

const CustomIcon = styled("span")(({ theme, checked }: { theme?: Theme; checked: boolean }) => ({
    width: 20,
    height: 20,
    borderRadius: 5,
    boxShadow: checked ? "0 0 0 0px rgb(16 22 26 / 40%)" : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme!.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
        theme!.palette.mode === "dark"
            ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
            : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
    },
    "input:disabled ~ &": {
        boxShadow: "none",
        background: theme!.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "#bebebe",
    },
}));

const CustomCheckedIcon = styled(CustomIcon)({
    backgroundColor: "#137cbd",
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
        width: 20,
        height: 20,
        display: "block",
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",

        content: '""',
    },
});

const CustomIndeterminateIcon = styled(CustomIcon)({
    backgroundColor: "#137cbd",
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
        width: 20,
        height: 20,
        display: "block",
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 8 16" id="dash"><g fill="none" fill-rule="evenodd"><g fill="%23ffffff"><path d="M0 7v2h8V7z"/></g></g></svg>');`,
        backgroundSize: "contain",
        content: '""',
    },
});

const CheckBox = forwardRef<HTMLButtonElement, CheckboxProps>(({ ...props }, ref) => (
    <MUICheckBox
        ref={ref}
        {...props}
        {...((props.indeterminate === true && props.checked === true) && {
            indeterminateIcon: <CustomIndeterminateIcon checked={props.checked || false} />,
        })}
        disableRipple
        color="default"
        inputProps={{ "aria-label": "Checkbox" }}
        icon={<CustomIcon checked={props.checked || false} />}
        checkedIcon={<CustomCheckedIcon checked={props.checked || false} />}
        sx={{
            "&:hover": { bgcolor: "transparent" },
        }}
    />
));

export default CheckBox;
